import { render, staticRenderFns } from "./ClientsPredict.vue?vue&type=template&id=98f755fe&scoped=true&"
import script from "./ClientsPredict.vue?vue&type=script&lang=js&"
export * from "./ClientsPredict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f755fe",
  null
  
)

export default component.exports